(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .factory("sessionService", ["DEFAULT_VALUES", "authService", "messageService", "$interval", "$rootScope", "$state", "$timeout", "$uibModal", "$translate", sessionService]);
    function sessionService(DEFAULT_VALUES, authService, messageService, $interval, $rootScope, $state, $timeout, $uibModal, $translate) {
        var sessionServiceFactory = {};
        var expiredTimeout;
        var showModalTimeout;
        var expiringModal;
        var cancelRefreshTokenListener;
        var expiryInterval;
        var init = function () {
            destroy();
            refreshExpiresIn();
            if (sessionServiceFactory.expiresIn > 0) {
                setTimeout();
            }
            cancelRefreshTokenListener = $rootScope.$on("refreshToken", function (_event, callback, params) {
                refreshToken(callback, params);
            });
        };
        var setTimeout = function () {
            if (expiredTimeout)
                $timeout.cancel(expiredTimeout);
            if (showModalTimeout)
                $timeout.cancel(showModalTimeout);
            refreshExpiresIn();
            //Redirects the user to the sign in page after the expiration
            expiredTimeout = $timeout(function () {
                destroy();
                authService.logOut().then(function () {
                    //close angular drawers
                    if ($rootScope.drawerRef)
                        $rootScope.drawerRef.dismiss();
                    $state.go("main.signIn");
                });
                messageService.warning("common.sessionExpired", { duration: 0 });
            }, sessionServiceFactory.expiresIn);
            //Shows the modal that the session is expiring
            showModalTimeout = $timeout(function () {
                expiringModal = $uibModal.open({
                    templateUrl: "app/templates/sbSessionExpiringModalTemplate.html",
                    controller: ["$scope", function ($scope) {
                            var vm = this;
                            vm.refresh = function () {
                                $scope.$dismiss();
                                refreshToken();
                            };
                            expiryInterval = $interval(function () {
                                refreshExpiresIn();
                                if (sessionServiceFactory.expiresIn <= 0) {
                                    sessionServiceFactory.expiresIn = 0;
                                }
                                console.log("expiryInterval: " + sessionServiceFactory.expiresIn);
                                var sessionCountDown = Math.floor(sessionServiceFactory.expiresIn / 1000);
                                vm.countDownMessage = $translate.instant("common.sessionExpiring.text", { seconds: sessionCountDown });
                                $scope.$digest(); //only affects the current scope
                                //$scope.$apply(); //scope apply calls $rootScope.$digest() so all scopes will be affected
                                //Closes the modal in all open tabs
                                if (expiringModal && expiringModal.opened.$$state.value && sessionServiceFactory.expiresIn > DEFAULT_VALUES.timeBeforeSessionExpires) {
                                    expiringModal.dismiss();
                                    setTimeout();
                                }
                            }, 1000, 0, false);
                        }],
                    controllerAs: "vm",
                    //scope: $scope,
                    backdrop: "static",
                    keyboard: false
                });
                expiringModal.result.then(function () {
                    if (expiryInterval)
                        $interval.cancel(expiryInterval);
                }, function () {
                    if (expiryInterval)
                        $interval.cancel(expiryInterval);
                });
            }, sessionServiceFactory.expiresIn - DEFAULT_VALUES.timeBeforeSessionExpires);
        };
        var refreshToken = function (callback, params) {
            authService.refreshToken().then(function () {
                refreshExpiresIn();
                setTimeout();
                if (callback)
                    callback(params);
            }, function () {
                destroy();
                authService.logOut().then(function () {
                    $state.go("main.signIn");
                });
                messageService.error("common.sessionRefreshError");
            });
        };
        var refreshExpiresIn = function () {
            sessionServiceFactory.expiresIn = new Date(authService.getTokenExpiryDate()).getTime() - new Date().getTime();
        };
        var destroy = function () {
            if (cancelRefreshTokenListener)
                cancelRefreshTokenListener();
            if (expiredTimeout)
                $timeout.cancel(expiredTimeout);
            if (showModalTimeout)
                $timeout.cancel(showModalTimeout);
            if (expiryInterval)
                $interval.cancel(expiryInterval);
        };
        $rootScope.$on("angularLogout", function () { destroy(); });
        sessionServiceFactory.refreshToken = refreshToken;
        sessionServiceFactory.init = init;
        sessionServiceFactory.destroy = destroy;
        return sessionServiceFactory;
    }
}());
